import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { AxiosResultDefaultError } from '../../../api/request';
import { getPeriodsAllRequest, Period } from '../../../api/requests/periods';
import { AuthenticationError } from '../../../api/requests/tuitionProcess';
import { createFetchContext } from '../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../components/info/DisplayError';
import Loading from '../../../components/info/Loading';

export interface PeriodsLoaderProps {
  periodId?: number | string;
  children: (periods: Period[]) => JSX.Element;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  undefined,
  Period[],
  AuthenticationError | AxiosResultDefaultError
>();

export const PeriodsLoaderConsumer = FetchConsumer;

export default function PeriodsLoader({
  periodId,
  children,
}: PeriodsLoaderProps) {
  const { id } = useParams<{ id: string }>();
  const periodIdFromUrl = periodId ? Number(periodId) : id;

  const request = useCallback(async () => {
    return getPeriodsAllRequest(periodIdFromUrl);
  }, [periodIdFromUrl]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return <Loading insideCard />;
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children(data);
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
